import { PmtOnboardingPopupVariant } from '@/modules/pmt/interfaces/tracking/trackingOnboardingPopup.interfaces';
import { Corner } from './Corner';
import { SimpleCenter } from './SimpleCenter';
import { TwoPanelCenter } from './TwoPanelCenter';

export const PopupComponentMapping: {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  [key in PmtOnboardingPopupVariant]: React.ComponentType<any>;
} = {
  [PmtOnboardingPopupVariant.TwoPanelCenter]: TwoPanelCenter,
  [PmtOnboardingPopupVariant.SimpleCenter]: SimpleCenter,
  [PmtOnboardingPopupVariant.Corner]: Corner,
};
